import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button, Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useCustomerAction, useModal } from "@/hooks";
import { useTestId } from "@/hooks";
import { EnergyFeatures, EnergyCost } from "@/components/Sections/Energy";
import { useEnergy } from "../.";
import { Certificate } from "../Certificate";
import { InteractionEnum } from "@/types";
import { Fragment } from "react";
import { ModalIds } from "@/constants";
export const EnergyModal = () => {
    const { t } = useI18n();
    const testId = useTestId("Sections.Energy");
    const { certificates, features } = useEnergy();
    const title = t("energy.headline");
    const { isOpen, open, toggle } = useModal(false, ModalIds.ENERGY);
    const { customerActionLeadInteraction } = useCustomerAction();
    const trackCustomerActionSectionReadMore = (title) => {
        customerActionLeadInteraction(InteractionEnum.OPEN_MORE, title);
    };
    return (_jsxs(_Fragment, { children: [(certificates === null || certificates === void 0 ? void 0 : certificates.length) > 0 && (_jsx(Box, { unsafe_className: "HideOnPrint", children: _jsx(Button, { variant: "secondary", isFullWidth: {
                        "breakpoint.base": true,
                        "breakpoint.sm": false,
                    }, marginTop: "spacing.8", testId: `${testId}.ModalButton`, onPress: () => {
                        trackCustomerActionSectionReadMore(title);
                        open();
                    }, children: t("energy.cta") }) })), _jsxs(Modal, { testId: `${testId}.Modal`, title: title, titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: toggle, children: [certificates === null || certificates === void 0 ? void 0 : certificates.map((certificate, index, arr) => (_jsxs(Fragment, { children: [_jsx(EnergyCost, { certificate: certificate }), _jsx(Certificate, { certificate: certificate, variant: "fullsize", isLast: index === arr.length - 1 })] }, certificate.key))), _jsx(Box, { paddingBottom: "spacing.16", children: _jsx(EnergyFeatures, { features: features, rootTestId: `${testId}.Features`, variant: "fullsize", showDivider: !!certificates }) })] })] }));
};
